<script setup lang="ts">
  import { type Anchor } from 'vuetify';
  import { VMenu } from 'vuetify/components/VMenu';

  const modelValue = defineModel<boolean>({ default: false });

  interface Props {
    activator?: Element | (string & {}) | 'parent';
    disabled?: boolean;
    location?: Anchor;
    closeOnContentClick?: boolean;
    openOnHover?: boolean;
    stickToTarget?: boolean;
    transition?: string;
    offset?: string | number | number[];
    eager?: boolean;
  }

  withDefaults(defineProps<Props>(), {
    activator: undefined,
    disabled: false,
    location: undefined,
    closeOnContentClick: true,
    openOnHover: false,
    stickToTarget: false,
    transition: 'v-menu-transition',
    offset: undefined,
    eager: false,
  });
</script>

<template>
  <v-menu
    v-model="modelValue"
    :activator
    :close-on-content-click
    :disabled
    :eager
    :location
    :offset
    :open-on-hover
    :stick-to-target
    :transition
  >
    <template #activator="{ props, isActive, targetRef }">
      <slot
        v-if="$slots.activator"
        :is-active
        name="activator"
        :props
        :target-ref
      />
    </template>

    <template #default="{ isActive }">
      <slot :is-active />
    </template>
  </v-menu>
</template>
